import React from 'react';
import { Avatar, Wrap } from '@leafwell/components';
import { getDateDay, getDateMonth, getDateYear } from 'lib/utils/dateUtils';

const MedicalReviewer: React.FC<{
  modified: string;
}> = ({ modified }) => {
  const modifiedAt = `${getDateMonth(modified)} ${getDateDay(
    modified,
  )}, ${getDateYear(modified)}`;

  return (
    <Wrap className="bg-lilac-50 items-center justify-center">
      <div className=" flex flex-row items-center gap-4">
        <div className="flex -space-x-2">
          <Avatar
            size="large"
            image="https://admin.leafwell.com/app/uploads/2025/10/Gavin-Moreland-headshot-for-bio.png"
            width="48"
            height="48"
            className="rounded-full ring-2 ring-white object-cover"
          />
        </div>
        <div className="text-base text-gray-700">
          <div className="mb-1">
            Content reviewed by{' '}
            <a
              className="text-purple-600 hover:underline"
              href="https://leafwell.com/blog/authors/dr-gavin-moreland"
            >
              Dr. Gavin Moreland
            </a>
          </div>
          <div className="text-xs text-gray-500">
            Last updated: {modifiedAt}
          </div>
        </div>
      </div>
    </Wrap>
  );
};

export default MedicalReviewer;
